import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Tooltip
} from "@material-ui/core";
import _ from "lodash";
import { clone, equals, forEach, forEachObjIndexed, map, omit } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Select from "react-select";
import {
  getClientConfig,
  GetClientConfigActionType
} from "src/clientMetadata/actions";
import { CommentPopover } from "src/commentView/CommentPopover";
import { Comment } from "src/commentView/types";
import { User } from "src/login/types";
import {
  updateSpreadMetadata,
  UpdateSpreadMetadataType
} from "src/metadata/actions";
import {
  getDropdownOptionFromMetadataValue,
  getTemplateTypeValueFromSpread,
  isCurrencyMetadataField,
  isDisabledMetadataFieldOnAboutPage,
  isTemplateTypeMetadataField,
  transformStringIntoDropdownOption
} from "src/metadata/helpers";
import {
  getMetadataAboutPageConfig,
  shouldDisplayCF
} from "src/metadata/selector";
import {
  MetadataFormKeys,
  MetadataFormState,
  MetadataFormStateItem,
  MetadataInput,
  MetadataInputOption,
  MetadataItem
} from "src/metadata/types";
import { actions, RequestProgressState } from "src/requestProgress/reducer";
import { getRequestProgress } from "src/requestProgress/selector";
import { DeleteRuleModal } from "src/ruleView/DeleteRuleModal";
import { SaveRulesModal } from "src/ruleView/SaveRulesModal";
import { showAlertBanner } from "src/shared/alertBanner/actions";
import { ALERT_BANNER_TYPES } from "src/shared/alertBanner/reducer";
import QuiqButton from "src/shared/QuiqButton";
import TextInput from "src/shared/TextInput";
import {
  isCreditLensFeatureEnabled,
  isDbsJwtLoginEnabled,
  isExportEnabled,
  showRejectSpread,
  showRejectSpreadPopup
} from "../../configState/selector";
import DocumentStatus from "../../documentList/DocumentStatus";
import { isCompletedState } from "../../documentList/helpers";
import { SPREAD_STATUSES } from "../../documentList/types";
import { getUser } from "../../login/selector";
import { UpdateMetadataConfigPayload } from "../../metadata/types";
import {
  isRequesting,
  transitionIfFinished
} from "../../requestProgress/helpers";
import selectorsToProps from "../../utils/selectorsToProps";
import { updateDebugStatus } from "../model/debug/actions";
import { getDebugState } from "../model/debug/selector";
import { deselectCells } from "../model/selectedCells/actions";
import {
  changeSpreadState,
  ChangeSpreadStateActionType,
  deleteRules,
  DeleteRulesActionType,
  exitMappingMode,
  rejectSpread,
  rejectSpreadActionType,
  SpreadStateChangeModel
} from "../model/spread/actions";
import {
  getMappingNodeId,
  getSpread,
  getSpreadId,
  getSpreadName,
  getSpreadVersion
} from "../model/spread/selector";
import {
  RuleChangeLog,
  RuleChangeLogItem,
  RuleHistory,
  Spread
} from "../model/spread/types";
import BalanceSheet from "./BalanceSheet";
import CashFlow from "./CashFlow";
import CashFlowFooter from "./CashFlowFooter";
import "./ChartOfAccountsSet.scss";
import { ConfirmDialog } from "./ConfirmDialog";
import DebugToggle from "./DebugToggle";
import ExportButton from "./ExportButton";
import { findCurrencyDropdownOptionFromName } from "./helpers";
import IncomeStatement from "./IncomeStatement";
import LockIconOutlined from "./lock-icon-outlined.svg";
import NetProfitFooter from "./NetProfitFooter";
import PersistentAccountingFormula from "./PersistentAccountingFormula";
import { RejectPopover } from "./reject/RejectPopover";

import { disableTagMode } from "./Tag/actions";
export interface ChartOfAccountsSetProps {
  spreadName: string;
  changeSpreadState: ChangeSpreadStateActionType;
  spreadId: string;
  updateDebugStatus: typeof updateDebugStatus;
  showAlertBanner: typeof showAlertBanner;
  spread: Spread | undefined;
  isDebug: boolean;
  user: User;
  redirectCallback: () => void;
  environmentName?: string;
  isCreditLens: boolean;
  requestProgress: RequestProgressState;
  mappingNodeId: string | null;
  exitMappingMode: typeof exitMappingMode;
  deselectCells: typeof deselectCells;
  deleteRulesAction: DeleteRulesActionType;
  activeTab: number;
  handleTabChange: (event: object, newValue: number) => void;
  spreadVersion: number;
  updateSpreadMetadata: UpdateSpreadMetadataType;
  metadataAboutPageConfig: MetadataInput[] | null;
  isDbsJwt: boolean;
  exportEnabled?: boolean;
  rejectSpreadAction: rejectSpreadActionType;
  showRejectSpread: boolean;
  showRejectSpreadPopup: boolean;
  disableTagMode: () => void;
  getClientConfig: GetClientConfigActionType;
  isReturnButtonClick?: boolean;
  shouldDisplayCF?: boolean;
}

interface ChartOfAccountsSetState {
  spreadCompleted: boolean;
  isDebug: boolean;
  isEditOrCompleteSpreadClick: boolean;
  isSaveRulesModalOpen: boolean;
  isDeleteRuleModalOpen: boolean;
  rules: RuleChangeLog;
  rulesToDelete: RuleChangeLogItem[];
  ruleInDeleteRuleConfirmModal: RuleChangeLogItem | null;
  ruleHistory: RuleHistory;
  initialChangelog: RuleChangeLog;
  reasonForReturnPopoverAnchorEl: HTMLElement | null;
  metadataFormState: MetadataFormState;
  confirmDialogOpen: boolean;
  requiredFieldsDialogOpen: boolean;
  returnForReviewComments: Comment[];
  ruleChangeAccepted: boolean;
  rejectReasonPopupOpen: boolean;
  rejected: boolean;
  isReturnButtonClick: boolean;
}
export class ChartOfAccountsSet extends React.Component<
  ChartOfAccountsSetProps,
  ChartOfAccountsSetState
> {
  public static getDerivedStateFromProps(
    props: ChartOfAccountsSetProps,
    state: ChartOfAccountsSetState
  ) {
    if (!props.isCreditLens) {
      const isFinishedState = transitionIfFinished(actions.changeSpreadState);
      if (
        isFinishedState &&
        isFinishedState.finished &&
        state.spreadCompleted
      ) {
        if (state.isEditOrCompleteSpreadClick) {
          props.showAlertBanner({
            type: ALERT_BANNER_TYPES.SUCCESS,
            message: "Success - Spread Completed."
          });
        } else {
          props.showAlertBanner({
            type: ALERT_BANNER_TYPES.SUCCESS,
            message: "Success - Spread Returned for Review."
          });
        }
        props.redirectCallback();
      }
    }
    if (props.spread) {
      const ruleChangeLog = { ...props.spread.ruleChangeLog };
      const oldRuleHistory = { ...state.ruleHistory };
      const newRuleHistory: RuleHistory = map(
        (rule: RuleChangeLogItem): RuleChangeLogItem[] => {
          const nodeRuleHistory = oldRuleHistory[rule.nodeId];
          if (nodeRuleHistory && nodeRuleHistory.length > 0) {
            if (equals(nodeRuleHistory[nodeRuleHistory.length - 1], rule)) {
              // If the spread rule is the same as top of history, don't add it again (nothing changed for this node)
              return [...nodeRuleHistory];
            } else if (
              (nodeRuleHistory.length > 1 &&
                equals(nodeRuleHistory[nodeRuleHistory.length - 2], rule)) ||
              (nodeRuleHistory.length === 1 &&
                equals(state.initialChangelog[rule.nodeId], rule))
            ) {
              // If the spread rule is the same as the previous rule or initial state rule, just remove the top rule (we did an undo)
              nodeRuleHistory.pop();
              return [...nodeRuleHistory];
            } else {
              // Else we did a remap, so add it to existing history
              return [...nodeRuleHistory, rule];
            }
          } else {
            // History currently doesn't exist, don't do anything if rule is same as initial, otherwise add as first rule
            if (equals(rule, state.initialChangelog[rule.nodeId])) {
              return [];
            } else {
              return [rule];
            }
          }
        },
        ruleChangeLog
      );
      return { ...state, ruleHistory: newRuleHistory };
    }
    return state;
  }

  private metaConfigStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderColor: state.isDisabled ? "rgba(0,0,0,0.26)" : "rgb(204, 204, 204)",
      color: state.isDisabled ? "rgba(0,0,0,0.38)" : "rgb(59, 62, 66)"
    })
  };

  constructor(props: ChartOfAccountsSetProps) {
    super(props);

    this.state = {
      spreadCompleted: false,
      isDebug: false,
      isEditOrCompleteSpreadClick: false,
      isSaveRulesModalOpen: false,
      isDeleteRuleModalOpen: false,
      rules: {},
      rulesToDelete: [],
      ruleInDeleteRuleConfirmModal: null,
      ruleHistory: {},
      initialChangelog: {},
      reasonForReturnPopoverAnchorEl: null,
      metadataFormState: {},
      confirmDialogOpen: false,
      requiredFieldsDialogOpen: false,
      returnForReviewComments: [],
      ruleChangeAccepted: false,
      rejectReasonPopupOpen: false,
      rejected: false,
      isReturnButtonClick: false
    };
  }

  public updateRules = () => {
    if (this.props.spread && this.props.spread.ruleChangeLog) {
      this.setState({ rules: this.props.spread.ruleChangeLog });
    }
  };

  public completeSpread = () => {
    const wasSpreadAlreadyComplete = this.state.spreadCompleted;
    this.setState(
      {
        spreadCompleted: !wasSpreadAlreadyComplete,
        isEditOrCompleteSpreadClick: true
      },
      () => {
        const reject = Boolean(this.props.spread && wasSpreadAlreadyComplete);
        this.props
          .changeSpreadState(
            this.getSpreadStateChangeModel({
              reject,
              rulesToDelete: this.state.rulesToDelete
            })
          )
          .then(this.redirectIfV2);
      }
    );
  };

  public redirectIfV2 = () => {
    if (!this.props.spread) {
      return;
    }

    if (!this.props.isCreditLens) {
      if (this.props.spread.canAdvance === false) {
        this.props.redirectCallback();
      }
    }
  };

  public promptForRulesChange = () => {
    if (this.hasRules()) {
      this.setState({ isSaveRulesModalOpen: true });
    }
  };

  public hasRules = () => {
    const { spread } = this.props;
    const { rulesToDelete } = this.state;

    const hasRules =
      spread &&
      (spread.entityId || spread.clientEntityId) &&
      spread.ruleChangeLog &&
      rulesToDelete &&
      rulesToDelete.length < Object.keys(spread.ruleChangeLog).length;

    return hasRules && !this.state.spreadCompleted;
  };

  public setSpreadRules = () => {
    if (!this.props.spread) {
      return;
    }

    if (this.props.spread.ruleChangeLog) {
      this.setState({
        rules: this.props.spread.ruleChangeLog,
        initialChangelog: this.props.spread.ruleChangeLog
      });
    }
  };

  public setIsSpreadCompleted = () => {
    const { spread, isCreditLens } = this.props;

    if (!spread) {
      return;
    }

    const spreadCompleted = isCreditLens
      ? isCompletedState(spread.status)
      : !spread.canAdvance;

    this.setState({ spreadCompleted });
  };

  public componentDidMount() {
    this.props.getClientConfig();
    this.setSpreadRules();
    this.initMetadataFormState();
    this.setIsSpreadCompleted();
  }

  public componentWillUnmount() {
    this.props.disableTagMode();
  }

  public returnSpreadForReview = () => {
    this.setState(
      {
        isEditOrCompleteSpreadClick: false,
        spreadCompleted: true
      },
      () => {
        this.props.changeSpreadState(
          this.getSpreadStateChangeModel({
            reject: true
          })
        );
      }
    );
  };

  public returnSpreadForReviewPopup = () => {
    setTimeout(() => {
      this.handlePopoverClose();
    }, 1000);
    this.setState(
      {
        isEditOrCompleteSpreadClick: false,
        spreadCompleted: true,
        isReturnButtonClick: true
      },
      () => {
        this.props.changeSpreadState(
          this.getSpreadStateChangeModel({
            reject: true
          })
        );
      }
    );
  };

  public rejectSpread = async (
    spreadId: string,
    reason: any,
    periods: string[],
    isCreditLens: boolean,
    commentText?: string
  ) => {
    const params = { spreadId, reason, periods, isCreditLens, commentText };

    try {
      await this.props.rejectSpreadAction(params);

      this.setState({
        rejectReasonPopupOpen: false,
        rejected: true
      });

      this.props.showAlertBanner({
        type: ALERT_BANNER_TYPES.SUCCESS,
        message: "Success - Spread Rejected."
      });
    } catch {
      this.setState({
        rejectReasonPopupOpen: false
      });

      this.props.showAlertBanner({
        type: ALERT_BANNER_TYPES.ERROR,
        message: "Error - Rejecting Spread."
      });
    }
  };

  public canReturnForReview = () => {
    const { spread, user, mappingNodeId, isCreditLens } = this.props;

    if (!spread) {
      return;
    }

    let currentQATeam;
    if (this.props.spread && this.props.spread.workflowModel) {
      currentQATeam = this.props.spread.workflowModel.qcTeams[0];
    }

    if (
      currentQATeam === this.props.user.qaTeams[0] &&
      this.props.spread &&
      this.props.spread.workflowModel &&
      this.props.spread.workflowModel.qcTeams.length > 1
    ) {
      return false;
    }

    if (!isCreditLens) {
      return spread.canReject;
    }

    return (
      spread.status === SPREAD_STATUSES.PENDING_FINAL_REVIEW &&
      user.hasManagedService &&
      user.isBankAnalyst &&
      !mappingNodeId
    );
  };

  public canReject = () => {
    const { spread, isCreditLens } = this.props;
    const { spreadCompleted } = this.state;

    if (
      !spread ||
      (isCreditLens && !this.props.showRejectSpreadPopup) ||
      !this.props.showRejectSpread ||
      (isCreditLens && spreadCompleted)
    ) {
      return false;
    }

    if (isCreditLens && !spreadCompleted) {
      return true;
    }

    return Boolean(
      spread.workflowModel && spread.workflowModel.currentTeamIndex === 0
    );
  };

  public canAdvance = () => {
    const { spread, mappingNodeId, isCreditLens } = this.props;

    if (!spread) {
      return;
    }

    if (!isCreditLens) {
      return spread.canAdvance;
    }

    return !mappingNodeId;
  };

  public toggleDebug = () => {
    this.props.updateDebugStatus(!this.props.isDebug);
  };

  public openSaveRulesModal = () =>
    this.setState({ isSaveRulesModalOpen: true });

  public closeSaveRulesModal = () => {
    this.setState({ isSaveRulesModalOpen: false });
  };

  public acceptAndCloseSaveRulesModal = () => {
    this.props.showAlertBanner({
      type: ALERT_BANNER_TYPES.SUCCESS,
      message: "Success - Rules Saved."
    });

    this.setState({
      isSaveRulesModalOpen: false,
      ruleChangeAccepted: true
    });

    this.promptForConfirmation();
  };

  public closeDeleteRuleModal = () => {
    this.setState({
      isDeleteRuleModalOpen: false,
      ruleInDeleteRuleConfirmModal: null
    });
  };

  public openDeleteRuleModal = (rule: RuleChangeLogItem) => {
    this.setState({
      isDeleteRuleModalOpen: true,
      ruleInDeleteRuleConfirmModal: rule
    });
  };

  public deleteRules = () => {
    if (this.state.rulesToDelete.length < 1) {
      return;
    }
    this.props.deleteRulesAction({
      spreadId: this.props.spreadId,
      rulesToDelete: this.state.rulesToDelete
    });
    this.setState({ rules: {} });
  };

  public getCompleteButtonText = () => {
    const { spreadCompleted } = this.state;
    const { isCreditLens, spread } = this.props;
    if (spread && !isCreditLens) {
      return "MARK AS COMPLETE";
    } else {
      return spreadCompleted ? "EDIT SPREAD" : "MARK AS COMPLETE";
    }
  };

  public getEditOrCompleteButton = () => {
    const { spread, isCreditLens } = this.props;
    const { isEditOrCompleteSpreadClick, spreadCompleted } = this.state;

    if (isCreditLens && spreadCompleted && window.allowEdit === false) {
      return;
    }

    // TODO create config field to disable COMPLETE/EDIT button for specified client.
    if (
      this.props.mappingNodeId ||
      !this.canAdvance() ||
      window.location.href.match(/\$zions-[a-zA-Z0-9-_/?#]*$/)
    ) {
      return;
    }

    return (
      <React.Fragment>
        <QuiqButton
          color="green"
          className="ChartOfAccountsSet__actions--editOrComplete"
          onClick={this.openEditOrComplete}
          isDisabled={
            isRequesting(actions.changeSpreadState) &&
            !isEditOrCompleteSpreadClick
          }
          isLoading={
            isRequesting(actions.changeSpreadState) &&
            isEditOrCompleteSpreadClick
          }
        >
          {this.getCompleteButtonText()}
        </QuiqButton>

        {spread && spread.ruleChangeLog && (
          <SaveRulesModal
            isOpen={
              this.state.isSaveRulesModalOpen &&
              !this.state.isDeleteRuleModalOpen
            }
            rules={this.state.rules}
            closeModal={this.closeSaveRulesModal}
            deleteRules={this.deleteRules}
            completeSpread={this.acceptAndCloseSaveRulesModal}
            openDeleteRuleModal={this.openDeleteRuleModal}
            updateRules={this.updateRules}
          />
        )}
        <DeleteRuleModal
          onClose={this.closeDeleteRuleModal}
          onConfirm={this.handleConfirmDeleteRuleClick}
          isOpen={this.state.isDeleteRuleModalOpen}
        />
      </React.Fragment>
    );
  };

  public returnForReviewPopup = () => {
    const { isCreditLens } = this.props;
    const { isReturnButtonClick, spreadCompleted } = this.state;

    if (isCreditLens && spreadCompleted) {
      return;
    }

    if (!isCreditLens) {
      return;
    }

    if (
      this.props.mappingNodeId ||
      !this.canAdvance() ||
      window.location.href.match(/\$zions-[a-zA-Z0-9-_/?#]*$/)
    ) {
      return;
    }

    return (
      spreadCompleted && (
        <div>
          <QuiqButton
            key={"button"}
            color="green"
            className="ChartOfAccountsSet__actions--reject"
            onClick={this.returnForReviewSpreadButtonClick}
            isDisabled={isReturnButtonClick}
            isLoading={isRequesting(actions.changeSpreadState)}
          >
            RETURN FOR REVIEW
          </QuiqButton>

          <CommentPopover
            key={"popover"}
            comments={this.state.returnForReviewComments}
            shouldHideInput={false}
            isOpen={Boolean(this.state.reasonForReturnPopoverAnchorEl)}
            spreadId={this.props.spreadId}
            onClose={this.handlePopoverClose}
            anchorEl={this.state.reasonForReturnPopoverAnchorEl}
            updateComments={this.addReasonForReturn}
            buttonText={"RETURN FOR REVIEW"}
            inputPlaceholderText={"Reason for return..."}
            popoverTitle={"Reason for Return"}
            popoverSubtitle={
              "Are you sure you want to proceed? Please leave a comment."
            }
            periodSelectors={
              this.props.spread && this.props.spread.financialTemplate.periods
            }
            onOptionalConfirm={this.returnSpreadForReviewPopup}
          />
        </div>
      )
    );
  };

  public render() {
    const { isCreditLens, spreadName, activeTab, spread } = this.props;
    const { spreadCompleted, isEditOrCompleteSpreadClick } = this.state;
    const { hasManagedService } = this.props.user;

    // @ts-ignore: Ignore "Object is possibly 'undefined'.""
    const singleItem =
      spread && spread.metadataFields.filter(item => item.name === "currency");
    const value =
      singleItem && singleItem.length > 0 ? singleItem[0].value : "";

    (window as any).currency = value;

    const legacySpreadStatus =
      (spread && (spread.status as SPREAD_STATUSES)) ||
      SPREAD_STATUSES.PENDING_REVIEW;

    const shouldDisplayBalanceSheet = activeTab === 0;
    const shouldDisplayIncomeStatement = activeTab === 1;
    let shouldDisplayCashFlow;
    let shouldDisplayAboutPage;

    if (
      this.props.shouldDisplayCF &&
      (this.props.spread &&
        this.props.spread.financialTemplate.cashFlows.length !== 0)
    ) {
      shouldDisplayCashFlow = activeTab === 2;
      shouldDisplayAboutPage = activeTab === 3;
    } else {
      shouldDisplayAboutPage = activeTab === 2;
    }

    if (this.state.rejected && !this.props.isCreditLens) {
      return (
        <Redirect
          to={{
            pathname: "/spreads"
          }}
        />
      );
    }

    return (
      <div className="ChartOfAccountsSet__container">
        <div className="ChartOfAccountsSet__header">
          <div className="Title__Row">
            <div className="Title__left">
              <h1 title={spreadName}>{spreadName}</h1>
            </div>
            <div className="Title__right ChartOfAccountsSet__actions">
              <div>
                {this.state.confirmDialogOpen && (
                  <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    displayText="Are you sure you want to proceed?"
                    onConfirm={this.handleSpreadButtonClick}
                    onCancel={this.closeConfirmDialog}
                    onClose={this.closeConfirmDialog}
                    isLoading={false}
                    isReject={false}
                    spreadId={this.props.spreadId}
                    confirmText={this.confirmText()}
                    cancelText="Go Back"
                    headerText={this.confirmText()}
                  />
                )}
                <ConfirmDialog
                  dialogOpen={this.state.requiredFieldsDialogOpen}
                  displayText="In order to continue, you will need to go to the about tab and complete the following fields:"
                  onConfirm={this.sendToAboutPage}
                  onCancel={this.closeRequiredFieldsDialog}
                  onClose={this.closeRequiredFieldsDialog}
                  isLoading={false}
                  isReject={false}
                  spreadId={this.props.spreadId}
                  confirmText={"Go To About Page"}
                  cancelText="Go Back"
                  headerText={"Missing Metadata in About Tab"}
                >
                  <div className="ChartOfAccountsSet__missing-required-fields">
                    {this.renderMissingMetadata()}
                  </div>
                </ConfirmDialog>
              </div>
              {this.props.exportEnabled && !this.props.isCreditLens && (
                <ExportButton />
              )}
              {this.canReturnForReview() && [
                <QuiqButton
                  key={"button"}
                  color="red"
                  className="ChartOfAccountsSet__actions--reject"
                  onClick={this.returnForReviewSpreadButtonClick}
                  isDisabled={
                    isRequesting(actions.changeSpreadState) &&
                    isEditOrCompleteSpreadClick
                  }
                  isLoading={
                    isRequesting(actions.changeSpreadState) &&
                    !isEditOrCompleteSpreadClick
                  }
                >
                  RETURN FOR REVIEW
                </QuiqButton>,

                <CommentPopover
                  key={"popover"}
                  comments={this.state.returnForReviewComments}
                  shouldHideInput={false}
                  isOpen={Boolean(this.state.reasonForReturnPopoverAnchorEl)}
                  spreadId={this.props.spreadId}
                  onClose={this.handlePopoverClose}
                  anchorEl={this.state.reasonForReturnPopoverAnchorEl}
                  updateComments={this.addReasonForReturn}
                  buttonText={"RETURN FOR REVIEW"}
                  inputPlaceholderText={"Reason for return..."}
                  popoverTitle={"Reason for Return"}
                  popoverSubtitle={
                    "Are you sure you want to proceed? Please leave a comment."
                  }
                  periodSelectors={
                    this.props.spread &&
                    this.props.spread.financialTemplate.periods
                  }
                  onOptionalConfirm={this.returnSpreadForReview}
                />
              ]}

              {this.getEditOrCompleteButton()}
              {this.returnForReviewPopup()}
              {this.canReject() && (
                <>
                  <QuiqButton
                    color="red"
                    className="ChartOfAccountsSet__actions--rejectSpread"
                    onClick={this.openRejectResonDialog}
                    isDisabled={
                      isRequesting(actions.rejectSpread) &&
                      !isEditOrCompleteSpreadClick
                    }
                    isLoading={
                      isRequesting(actions.rejectSpread) &&
                      isEditOrCompleteSpreadClick
                    }
                  >
                    {"reject spread"}
                  </QuiqButton>

                  <RejectPopover
                    key={"rejectPopover"}
                    isOpen={Boolean(this.state.rejectReasonPopupOpen)}
                    spreadId={this.props.spreadId}
                    onClose={this.handleRejectPopoverClose}
                    anchorEl={this.state.reasonForReturnPopoverAnchorEl}
                    periods={
                      (this.props.spread &&
                        this.props.spread.financialTemplate.periods) ||
                      []
                    }
                    onSubmit={this.rejectSpread}
                    isCreditLens={this.props.isCreditLens}
                  />
                </>
              )}

              {this.props.mappingNodeId && (
                <QuiqButton
                  color="white"
                  className="ChartOfAccountsSet__actions--exitMappingMode"
                  onClick={this.handleExitMappingMode}
                  variant={"outlined"}
                >
                  EXIT MAPPING MODE
                </QuiqButton>
              )}
            </div>
          </div>

          <div className="ChartOfAccountsSet__tabs__container">
            <div className="ChartOfAccountsSet__tabs__inner-container">
              <Tabs
                className="ChartOfAccountsSet__tabs"
                value={activeTab}
                onChange={this.props.handleTabChange}
                classes={{
                  indicator: "ChartOfAccountsSet__tabs__indicator"
                }}
              >
                <Tab
                  className="ChartOfAccountsSet__tabs__tab"
                  label="BALANCE SHEET"
                  classes={{
                    labelContainer: "ChartOfAccountsSet__tabs__tab__label",
                    selected: "ChartOfAccountsSet__tabs__tab--selected"
                  }}
                  disableRipple={true}
                />
                <Tab
                  className="ChartOfAccountsSet__tabs__tab"
                  label="INCOME STATEMENT"
                  classes={{
                    labelContainer: "ChartOfAccountsSet__tabs__tab__label",
                    selected: "ChartOfAccountsSet__tabs__tab--selected"
                  }}
                  disableRipple={true}
                />
                {this.props.shouldDisplayCF &&
                  (this.props.spread &&
                    this.props.spread.financialTemplate.cashFlows.length !==
                      0) && (
                    <Tab
                      className="ChartOfAccountsSet__tabs__tab"
                      label="CASH FLOW"
                      classes={{
                        labelContainer: "ChartOfAccountsSet__tabs__tab__label",
                        selected: "ChartOfAccountsSet__tabs__tab--selected"
                      }}
                      disableRipple={true}
                    />
                  )}
                {
                  <Tab
                    className="ChartOfAccountsSet__tabs__tab"
                    label="ABOUT"
                    classes={{
                      labelContainer: "ChartOfAccountsSet__tabs__tab__label",
                      selected: "ChartOfAccountsSet__tabs__tab--selected"
                    }}
                    disableRipple={true}
                  />
                }
              </Tabs>
              <DebugToggle
                toggleDebug={this.toggleDebug}
                isDebug={this.props.isDebug}
              />
            </div>
            {spreadCompleted ? (
              <DocumentStatus
                hasManagedService={hasManagedService}
                status={SPREAD_STATUSES.REVIEW_COMPLETED}
                isLocked={false}
                rejected={false}
                humanReadableStatus={
                  !isCreditLens
                    ? spread && spread.humanReadableStatus
                    : this.state.isReturnButtonClick
                    ? "In Review"
                    : undefined
                }
              />
            ) : (
              <DocumentStatus
                hasManagedService={hasManagedService}
                status={
                  isCreditLens
                    ? SPREAD_STATUSES.PENDING_REVIEW
                    : legacySpreadStatus
                }
                isLocked={true}
                rejected={false}
                humanReadableStatus={
                  !isCreditLens
                    ? spread && spread.humanReadableStatus
                    : this.state.isReturnButtonClick
                    ? "In Review"
                    : undefined
                }
              />
            )}
          </div>
        </div>
        {shouldDisplayBalanceSheet && (
          <PersistentAccountingFormula spread={this.props.spread} />
        )}
        {shouldDisplayIncomeStatement && (
          <NetProfitFooter spread={this.props.spread} />
        )}
        {shouldDisplayCashFlow && <CashFlowFooter spread={this.props.spread} />}
        <div className={"scrolling"}>
          {shouldDisplayBalanceSheet && (
            <div id="balance" className="balance__container">
              <BalanceSheet
                chartOfAccounts={
                  spread && spread.financialTemplate.balanceSheetsV2
                }
                ruleHistory={this.state.ruleHistory}
                initialChangelog={this.state.initialChangelog}
              />
            </div>
          )}
          {shouldDisplayIncomeStatement && (
            <div id="incomestatement">
              <IncomeStatement
                chartOfAccounts={
                  spread && spread.financialTemplate.incomeStatementsV2
                }
                ruleHistory={this.state.ruleHistory}
                initialChangelog={this.state.initialChangelog}
              />
            </div>
          )}
          {shouldDisplayCashFlow && (
            <div id="cashFlow">
              <CashFlow
                chartOfAccounts={spread && spread.financialTemplate.cashFlowsV2}
                ruleHistory={this.state.ruleHistory}
                initialChangelog={this.state.initialChangelog}
              />
            </div>
          )}
          {shouldDisplayAboutPage && this.renderAboutPage()}
        </div>
        {this.props.isCreditLens &&
          (this.state.rejected ||
            (this.props.spread && this.props.spread.status === "REJECTED")) && (
            <Modal
              open={this.handleModalOpen()}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              <div
                style={{
                  top: "50%",
                  left: "50%",
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  backgroundColor: "white",
                  padding: "16px",
                  border: "1px solid #000",
                  boxShadow: "24",
                  outline: 0,
                  borderRadius: "8px",
                  borderColor: "#001966", // Blue border color
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column"
                }}
              >
                <h2
                  id="simple-modal-title"
                  style={{
                    color: "#001966",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  Rejected
                </h2>{" "}
                {/* Blue title color */}
                <p id="simple-modal-description" style={{ marginTop: 16 }}>
                  The document has been rejected.
                </p>
              </div>
            </Modal>
          )}
        )
      </div>
    );
  }

  private handleModalOpen = () => {
    if (
      this.state.rejected ||
      (this.props.spread && this.props.spread.status === "REJECTED")
    ) {
      return true;
    } else {
      return false;
    }
  };

  private handleSpreadButtonClick = (event?: React.MouseEvent<HTMLElement>) => {
    this.completeSpread();
    this.closeConfirmDialog();
  };

  private closeConfirmDialog = () => {
    this.setState({
      confirmDialogOpen: false
    });
  };

  private openConfirmDialog = () => {
    this.setState({ confirmDialogOpen: true });
  };

  private postMetadataToBackend = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    const metadataPayload: UpdateMetadataConfigPayload = {
      spreadId: this.props.spreadId,
      userId: this.props.user.userId,
      spreadVersion: this.props.spreadVersion,
      items: [],
      isFE: true
    };

    const periodTypes = this.props.spread ? this.props.spread.periodTypes : [];

    forEachObjIndexed(
      (metadataField: MetadataFormStateItem, formKey: string | number) => {
        if (
          typeof formKey === "string" &&
          formKey.indexOf("SecondPeriod") > 0
        ) {
          return;
        }

        let item: MetadataItem;
        if (
          formKey === MetadataFormKeys.BalanceSheetDate &&
          this.state.metadataFormState[`${formKey}SecondPeriod`] &&
          this.state.metadataFormState[formKey].value !== null
        ) {
          item = {
            name: formKey,
            periodValues: [
              {
                period: periodTypes[0][MetadataFormKeys.Period],
                value: this.state.metadataFormState[formKey].value
              },
              {
                period: periodTypes[1][MetadataFormKeys.Period],
                value: this.state.metadataFormState[`${formKey}SecondPeriod`]
                  .value
              }
            ]
          };
        } else if (
          formKey === MetadataFormKeys.BalanceSheetDate &&
          this.state.metadataFormState[`${formKey}SecondPeriod`]
        ) {
          item = {
            name: formKey,
            periodValues: [
              {
                period: periodTypes[1][MetadataFormKeys.Period],
                value: this.state.metadataFormState[`${formKey}SecondPeriod`]
                  .value
              }
            ]
          };
        } else if (
          formKey === MetadataFormKeys.BalanceSheetDate &&
          this.state.metadataFormState[formKey] &&
          this.state.metadataFormState[formKey].value !== null
        ) {
          item = {
            name: formKey,
            periodValues: [
              {
                period: periodTypes[0][MetadataFormKeys.Period],
                value: this.state.metadataFormState[formKey].value
              }
            ]
          };
        } else if (
          formKey === MetadataFormKeys.AuditMethod ||
          formKey === MetadataFormKeys.AuditorName
        ) {
          const secondPeriodValue = this.state.metadataFormState[
            `${formKey}SecondPeriod`
          ]
            ? this.state.metadataFormState[`${formKey}SecondPeriod`].value
            : null;

          if (
            formKey !== MetadataFormKeys.AuditorName &&
            !metadataField.value &&
            !secondPeriodValue
          ) {
            return;
          }
          item = {
            name: formKey,
            value:
              metadataField.value && metadataField.value === secondPeriodValue
                ? metadataField.value
                : ""
          };
          item.periodValues = item.periodValues ? item.periodValues : [];
          if (metadataField.value !== null) {
            item.periodValues.push({
              period: periodTypes[0][MetadataFormKeys.Period],
              value: metadataField.value
            });
          }
          if (secondPeriodValue !== null) {
            item.periodValues.push({
              period: periodTypes[1][MetadataFormKeys.Period],
              value: secondPeriodValue
            });
          }
        } else {
          if (metadataField.value === null) {
            return;
          }
          item = {
            name: formKey,
            value: metadataField.value
          };
        }
        metadataPayload.items = [...metadataPayload.items, item];
      },
      this.state.metadataFormState
    );

    const confirmUpdate = () => {
      let letUpdate = true;
      for (const item in this.state.metadataFormState) {
        if (
          this.state.metadataFormState[item].shouldShowError ||
          this.state.metadataFormState[item].shouldShowErrorNegative
        ) {
          letUpdate = false;
        }
      }
      return letUpdate;
    };

    if (confirmUpdate()) {
      this.props
        .updateSpreadMetadata(metadataPayload)
        .then(this.onUpdateMetadataSuccess)
        .catch(this.onUpdateMetadataError);
    }
  };

  private onUpdateMetadataSuccess = (data: any) => {
    _.each(data.metadata.items, item => {
      if (this.props.spread && !item.periodValues) {
        this.props.spread.metadataFields.forEach(element => {
          if (element.name === item.name) {
            element.value = item.value;
          }
        });
      } else if (this.props.spread) {
        this.props.spread.metadataFields.forEach(element => {
          if (element.name === "balanceSheetDateEndDate") {
            this.props.spread &&
            this.props.spread.periodTypes[0].period ===
              item.periodValues[0].period
              ? (element.value = item.periodValues[0].value)
              : (element.valueForP2 = item.periodValues[0].value);
          }
        });
        this.props.spread.periodTypes.map(periodType => {
          _.each(item.periodValues, value => {
            if (periodType.period === value.period) {
              periodType[item.name] = value.value;
            }
          });

          return periodType;
        });
      }
    });

    this.props.showAlertBanner({
      type: ALERT_BANNER_TYPES.SUCCESS,
      message: "Metadata updated successfully."
    });
  };

  private onUpdateMetadataError = () => {
    this.props.showAlertBanner({
      type: ALERT_BANNER_TYPES.ERROR,
      message: "Metadata couldn't be updated."
    });
  };

  private renderAboutPage = () => {
    if (!this.props.spread) {
      return;
    }

    const entityName = this.props.spread.entityName || "";

    const numOfPeriods = String(
      this.props.spread.financialTemplate.periods.length
    );

    const highPriorityValue = Boolean(this.props.spread.priority);

    return (
      <div className="AboutPage">
        <div className="AboutPage__entity AboutPage__field">
          <label
            className="AboutPage__entity__label"
            htmlFor="AboutPage__entity__input"
          >
            Entity
            <Tooltip
              classes={{ tooltip: "ToolTip-container" }}
              title="Entity is not editable"
              placement="top"
            >
              <img src={LockIconOutlined} />
            </Tooltip>
          </label>

          <TextField
            className="AboutPage__entity__input AboutPage__row"
            variant="outlined"
            disabled={true}
            value={entityName}
          />
        </div>
        <div className="AboutPage__period AboutPage__field">
          <label className="AboutPage__period__label">
            Period
            <Tooltip
              classes={{ tooltip: "ToolTip-container" }}
              title="Period is not editable"
              placement="top"
            >
              <img src={LockIconOutlined} />
            </Tooltip>
          </label>
          <FormControl
            disabled={true}
            className="AboutPage__period__amount AboutPage__period__radio-group"
          >
            <RadioGroup name="numPeriods" row={true} value={numOfPeriods}>
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label="One Period"
                className="AboutPage__period__radio"
              />
              <FormControlLabel
                value="2"
                control={<Radio color="primary" />}
                label="Two Periods"
                className="AboutPage__period__radio"
              />
            </RadioGroup>
          </FormControl>
          <TextField
            className="AboutPage__period__year AboutPage__row"
            variant="outlined"
            disabled={true}
            value={this.props.spread.financialTemplate.periods.join(", ")}
          />
        </div>
        {this.renderMetadataFields(
          this.props.spread.financialTemplate.periods.length
        )}
        {this.props.spread.purgeDateTime && (
          <div className="AboutPage__field">
            <label className="AboutPage__purge__date__label">
              PURGE DATE
              <Tooltip
                classes={{ tooltip: "ToolTip-container" }}
                title="Purge Date Peirod is not editable"
                placement="top"
              >
                <img src={LockIconOutlined} />
              </Tooltip>
            </label>
            <TextField
              className="AboutPage__row AboutPage__purge__date"
              variant="outlined"
              disabled={true}
              value={this.props.spread.purgeDateTime}
            />
          </div>
        )}
        <div className="AboutPage__high-priority AboutPage__field">
          <Checkbox
            id="priority"
            name="priority"
            color="primary"
            defaultChecked={highPriorityValue}
            className={"AboutPage__high-priority__input"}
            onChange={this.handleCheckboxChange("priority")}
            disabled={this.state.spreadCompleted}
          />
          <label className="AboutPage__high-priority__label" htmlFor="priority">
            High Priority
          </label>
        </div>
        <div className="AboutPage__submit">
          <QuiqButton
            className="AboutPage__submit__button"
            color="blue"
            onClick={this.postMetadataToBackend}
            isLoading={isRequesting(actions.updateSpreadMetadata)}
            isDisabled={this.state.spreadCompleted}
          >
            Update
          </QuiqButton>
        </div>
      </div>
    );
  };

  private renderMetadataFields = (numberOfPeriods: number) => {
    if (!this.props.metadataAboutPageConfig) {
      return null;
    }

    return map(formFieldData => {
      const { formKey } = formFieldData;
      const isDisabled = isDisabledMetadataFieldOnAboutPage(formFieldData);
      const { AuditMethod, AuditorName } = MetadataFormKeys;
      const isAuditField = formKey === AuditMethod || formKey === AuditorName;

      const periodOne =
        this.props.spread &&
        this.props.spread.periodTypes[0][MetadataFormKeys.Period];

      const periodTwo =
        this.props.spread &&
        numberOfPeriods === 2 &&
        this.props.spread.periodTypes[1][MetadataFormKeys.Period];

      const isPerPeriod =
        (numberOfPeriods === 2 && !!formFieldData.isPerPeriod) ||
        (numberOfPeriods === 2 && isAuditField) ||
        (numberOfPeriods === 2 && formKey === "balanceSheetDateEndDate");
      const labelContainerClass = isPerPeriod
        ? "AboutPageForm__label__container"
        : "";

      const containerClass = isPerPeriod ? "AboutPageForm__container" : "";

      return (
        <div className={`AboutPage__${formKey} AboutPage__field`} key={formKey}>
          <div className={labelContainerClass}>
            {this.getLabel(formFieldData, periodOne, isPerPeriod)}
            {isPerPeriod &&
              this.getLabel(formFieldData, periodTwo, isPerPeriod)}
          </div>
          <div className={containerClass}>
            {this.getSelectField(formFieldData, false)}
            {isPerPeriod && this.getSelectField(formFieldData, isPerPeriod)}

            {/* TODO bring code blocks below to the above one format */}
            {formFieldData.inputType === "text" && (
              <TextInput
                className={`AboutPageForm__period-1 AboutPage__${formKey}__input AboutPage__row`}
                isNumeric={formFieldData.isNumericType}
                isDate={formFieldData.isDateType}
                placeholder={
                  this.state.spreadCompleted ? "" : formFieldData.label
                }
                maxLength={
                  formFieldData.maxLength ? formFieldData.maxLength : 250
                }
                required={formFieldData.isRequiredOnComplete}
                value={this.valueFor(formFieldData.formKey, 0)}
                name={formFieldData.formKey}
                onChange={this.handleMetadataTextInputChange(formKey)}
                disabled={this.state.spreadCompleted || isDisabled}
              />
            )}

            {numberOfPeriods === 2 &&
              formFieldData.formKey === MetadataFormKeys.AuditorName && (
                <TextInput
                  className={`AboutPageForm__period-1 AboutPageForm__period-2 AboutPage__${formKey}__input AboutPage__row`}
                  isNumeric={formFieldData.isNumericType}
                  isDate={formFieldData.isDateType}
                  placeholder={formFieldData.label}
                  maxLength={255}
                  required={formFieldData.isRequiredOnComplete}
                  value={this.valueFor(
                    `${formFieldData.formKey}SecondPeriod`,
                    1
                  )}
                  name={`${formFieldData.formKey}SecondPeriod`}
                  onChange={this.handleMetadataTextInputChange(
                    `${formFieldData.formKey}SecondPeriod`
                  )}
                  disabled={this.state.spreadCompleted}
                />
              )}
            {numberOfPeriods === 2 &&
              formFieldData.formKey === "balanceSheetDateEndDate" && (
                <TextInput
                  className={`AboutPageForm__period-1 AboutPageForm__period-2 AboutPage__${formKey}__input AboutPage__row`}
                  isNumeric={formFieldData.isNumericType}
                  isDate={formFieldData.isDateType}
                  placeholder={formFieldData.label}
                  maxLength={255}
                  required={formFieldData.isRequiredOnComplete}
                  value={this.valueForSecondPeriod(
                    `${formFieldData.formKey}SecondPeriod`,
                    formFieldData.formKey
                  )}
                  name={`${formFieldData.formKey}SecondPeriod`}
                  onChange={this.handleMetadataTextInputChange(
                    `${formFieldData.formKey}SecondPeriod`
                  )}
                  disabled={this.state.spreadCompleted}
                />
              )}
          </div>
          {this.state.metadataFormState[formFieldData.formKey]
            .shouldShowError && (
            <div className="DocumentUploadForm__error-msg .form__helper-text-about">
              {formFieldData.label} value can not transcend{" "}
              {formFieldData.maxValue}
            </div>
          )}
          {this.state.metadataFormState[formFieldData.formKey]
            .shouldShowErrorNegative && (
            <div className="DocumentUploadForm__error-msg .form__helper-text-about">
              {formFieldData.label} value can not be negative
            </div>
          )}
        </div>
      );
    }, this.props.metadataAboutPageConfig);
  };

  private valueFor = (formKey: string, period: number): string => {
    if (!this.props.spread) {
      return "";
    }

    let value =
      this.state.metadataFormState[formKey] &&
      this.state.metadataFormState[formKey].value;

    if (value === null || value === undefined) {
      if (
        typeof formKey === "string" &&
        formKey.indexOf(MetadataFormKeys.AuditorName) >= 0
      ) {
        value =
          this.props.spread.periodTypes[period] &&
          this.props.spread.periodTypes[period][MetadataFormKeys.AuditorName];
      } else {
        const singleItem = this.props.spread.metadataFields.filter(
          item => item.name === formKey
        );
        value = singleItem.length > 0 ? singleItem[0].value : "";
      }
    }
    if (typeof value === "string") {
      return value;
    } else {
      return "";
    }
  };

  private valueForSecondPeriod = (
    formKeyForP2: string,
    formKey: string
  ): string => {
    if (!this.props.spread) {
      return "";
    }

    let value =
      this.state.metadataFormState[formKeyForP2] &&
      this.state.metadataFormState[formKeyForP2].value;

    if (value === null || value === undefined) {
      const singleItem = this.props.spread.metadataFields.filter(
        item => item.name === formKey
      );
      value = singleItem.length > 0 ? singleItem[0].valueForP2 : "";
    }

    if (typeof value === "string") {
      return value;
    } else {
      return "";
    }
  };

  private handleMetadataTextInputChange = (formKey: string) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!this.props.metadataAboutPageConfig) {
      return;
    }

    const value = event.target.value;

    const singleItem = this.props.metadataAboutPageConfig.filter(
      item => item.formKey === formKey
    );

    if (
      singleItem.length > 0 &&
      singleItem[0].isNumericType &&
      Number(value) > Number(singleItem[0].maxValue)
    ) {
      const oldMetadataFormState = { ...this.state.metadataFormState };
      const newMetadataFormState: MetadataFormState = {
        ...oldMetadataFormState,
        [formKey]: { value, shouldShowError: true }
      };
      this.setState({ metadataFormState: newMetadataFormState });
    } else if (
      singleItem.length > 0 &&
      singleItem[0].formKey === "cocunut" &&
      Number(value) < 0
    ) {
      const oldMetadataFormState = { ...this.state.metadataFormState };
      const newMetadataFormState: MetadataFormState = {
        ...oldMetadataFormState,
        [formKey]: {
          value,
          shouldShowError: false,
          shouldShowErrorNegative: true
        }
      };
      this.setState({ metadataFormState: newMetadataFormState });
    } else {
      const oldMetadataFormState = { ...this.state.metadataFormState };
      const newMetadataFormState: MetadataFormState = {
        ...oldMetadataFormState,
        [formKey]: { value, shouldShowError: false }
      };
      this.setState({ metadataFormState: newMetadataFormState });
    }
  };

  private handleMetadataInputChange = (formKey: string) => (
    option: MetadataInputOption
  ) => {
    if (!this.props.metadataAboutPageConfig) {
      return;
    }
    let value;
    if (option == null) {
      value = "-";
    } else {
      value = option && option.value;
    }
    const oldMetadataFormState = { ...this.state.metadataFormState };
    const newMetadataFormState: MetadataFormState = {
      ...oldMetadataFormState,
      [formKey]: { value, shouldShowError: false }
    };

    this.setState({ metadataFormState: newMetadataFormState });
  };

  private handleCheckboxChange = (formKey: string) => (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (!this.props.metadataAboutPageConfig) {
      return;
    }
    const oldMetadataFormState = { ...this.state.metadataFormState };
    const newMetadataFormState: MetadataFormState = {
      ...oldMetadataFormState,
      [formKey]: { value: String(checked), shouldShowError: false }
    };
    this.setState({ metadataFormState: newMetadataFormState });
  };

  private initMetadataFormState = () => {
    if (!this.props.metadataAboutPageConfig) {
      return;
    }

    const metadataFormState: MetadataFormState = {};

    forEach(configField => {
      const formField: MetadataFormStateItem = {
        value: null,
        shouldShowError: false
      };
      metadataFormState[configField.formKey] = formField;
    }, this.props.metadataAboutPageConfig);

    this.setState({ metadataFormState });
  };

  private getMetadataInputOption = (
    formFieldData: MetadataInput,
    period: number
  ): MetadataInputOption | null => {
    if (!this.props.spread) {
      return null;
    }

    const { formKey, options } = formFieldData;
    let value: MetadataInputOption;
    let valueFromSpreadData;

    if (isTemplateTypeMetadataField(formKey)) {
      valueFromSpreadData = getTemplateTypeValueFromSpread(this.props.spread);
      value = getDropdownOptionFromMetadataValue(valueFromSpreadData);
      return value;
    }

    const { workflowModel } = this.props.spread;
    if (
      formKey === MetadataFormKeys.QCTeam1 &&
      workflowModel &&
      workflowModel.qcTeams &&
      workflowModel.qcTeams.length > 0
    ) {
      valueFromSpreadData = workflowModel.qcTeams[0];
    } else if (
      formKey === MetadataFormKeys.QCTeam2 &&
      workflowModel &&
      workflowModel.qcTeams &&
      workflowModel.qcTeams.length > 1
    ) {
      valueFromSpreadData = workflowModel.qcTeams[1];
    } else if (formKey === MetadataFormKeys.AuditMethod) {
      valueFromSpreadData =
        this.props.spread.periodTypes[period] &&
        this.props.spread.periodTypes[period][MetadataFormKeys.AuditMethod];
    } else if (formKey === MetadataFormKeys.AuditorName) {
      valueFromSpreadData =
        this.props.spread.periodTypes[period] &&
        this.props.spread.periodTypes[period][MetadataFormKeys.AuditorName];
    } else {
      const singleId = this.props.spread.metadataFields.filter(
        item => item.name === formKey
      );
      valueFromSpreadData = singleId.length > 0 ? singleId[0].value : "";
    }

    if (!valueFromSpreadData) {
      return null;
    }

    if (isCurrencyMetadataField(formKey)) {
      value = findCurrencyDropdownOptionFromName(valueFromSpreadData, options);
      return value;
    }

    value = transformStringIntoDropdownOption(valueFromSpreadData);

    return value;
  };

  private handleConfirmDeleteRuleClick = () => {
    const { ruleInDeleteRuleConfirmModal } = this.state;
    const rulesToDelete = clone(this.state.rulesToDelete);

    if (ruleInDeleteRuleConfirmModal) {
      rulesToDelete.push(ruleInDeleteRuleConfirmModal);
      const newRules = omit(
        [ruleInDeleteRuleConfirmModal.accountId],
        this.state.rules
      );
      this.setState({ rules: newRules, rulesToDelete });
    }
    this.closeDeleteRuleModal();
  };

  private handleExitMappingMode = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    const isLoading =
      isRequesting(actions.undoRule) ||
      isRequesting(actions.remapAccount) ||
      isRequesting(actions.mapUnmappedAccount) ||
      isRequesting(actions.unmapHiddenAccountRow);

    if (isLoading) {
      return;
    }

    this.props.exitMappingMode();
    this.props.deselectCells();
    this.setState({ ruleChangeAccepted: false });
  };

  private getSpreadStateChangeModel(params: {
    reject: boolean;
    rulesToDelete?: RuleChangeLogItem[];
  }): SpreadStateChangeModel {
    return {
      bankAnalyst: this.props.user.isBankAnalyst,
      edit: false,
      environmentName: this.props.environmentName,
      managedService: this.props.user.hasManagedService,
      reject: params.reject,
      spreadId: this.props.spreadId,
      rulesToDelete: params.rulesToDelete
    };
  }

  private confirmText = () => {
    if (this.props.isCreditLens && this.state.spreadCompleted) {
      return "Edit Spread";
    }

    return !this.canAdvance() && this.canReturnForReview()
      ? "Return for Review"
      : "Mark as Complete";
  };

  private returnForReviewSpreadButtonClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    this.setState({
      reasonForReturnPopoverAnchorEl: event.currentTarget
    });
  };

  private handlePopoverClose = () => {
    this.setState({ reasonForReturnPopoverAnchorEl: null });
  };

  private openRejectResonDialog = () => {
    this.setState({ rejectReasonPopupOpen: true });
  };

  private handleRejectPopoverClose = () => {
    this.setState({ rejectReasonPopupOpen: false });
  };

  private addReasonForReturn = (comments: Comment[]) => {
    if (comments.length > 0) {
      this.setState({ returnForReviewComments: comments });
    }
  };

  private checkRequiredAboutPageFieldsAreFilledOut = () => {
    return this.requiredButMissingMetadata().length === 0;
  };

  private requiredButMissingMetadata = (): MetadataInput[] => {
    const config = this.props.metadataAboutPageConfig;
    const numOfPeriods =
      this.props.spread && this.props.spread.financialTemplate.periods.length;

    return (config || []).filter(formFieldData => {
      let value2: any = true;

      const value = this.getMetadataInputOption(formFieldData, 0);

      if (numOfPeriods && numOfPeriods > 1) {
        if (formFieldData.formKey === "balanceSheetDateEndDate") {
          const singleId =
            this.props.spread &&
            this.props.spread.metadataFields.filter(
              item => item.name === "balanceSheetDateEndDate"
            );
          value2 =
            singleId && singleId.length > 0 ? singleId[0].valueForP2 : "";
        } else {
          value2 = this.getMetadataInputOption(formFieldData, 1);
        }
      }

      const isRequired = formFieldData.isRequiredOnComplete;
      if (
        isRequired &&
        this.state.metadataFormState[formFieldData.formKey] &&
        this.state.metadataFormState[formFieldData.formKey].value === "-"
      ) {
        return formFieldData;
      }

      return isRequired && (!value || !value2) ? formFieldData : false;
    });
  };

  private renderMissingMetadata = () => {
    return _.map(this.requiredButMissingMetadata(), field => {
      return <span key={field.label}>- {field.label}</span>;
    });
  };

  private openEditOrComplete = () => {
    if (this.hasRules() && !this.state.ruleChangeAccepted) {
      this.promptForRulesChange();
    } else {
      this.promptForConfirmation();
    }
  };

  private promptForConfirmation = () => {
    const shouldValidateMetadata =
      this.props.spread &&
      this.props.spread.workflowModel &&
      this.props.spread.workflowModel.qcTeams.length ===
        this.props.spread.workflowModel.currentTeamIndex + 1;

    if (
      shouldValidateMetadata &&
      !this.checkRequiredAboutPageFieldsAreFilledOut()
    ) {
      this.setState({ requiredFieldsDialogOpen: true });
      return;
    }

    this.openConfirmDialog();
  };

  private closeRequiredFieldsDialog = () => {
    this.setState({
      requiredFieldsDialogOpen: false
    });
  };

  private sendToAboutPage = (event?: React.MouseEvent<HTMLElement>) => {
    const tab =
      this.props.spread &&
      this.props.shouldDisplayCF &&
      this.props.spread.financialTemplate.cashFlows.length !== 0
        ? 3
        : 2;
    this.props.handleTabChange({}, tab);
    this.closeRequiredFieldsDialog();
  };

  private getLabel = (
    formFieldData: MetadataInput,
    period: string | false | undefined,
    isPerPeriod: boolean
  ) => {
    const { formKey, label } = formFieldData;
    const isDisabled = isDisabledMetadataFieldOnAboutPage(formFieldData);
    const { QCTeam1, QCTeam2 } = MetadataFormKeys;

    let id;
    const singleId =
      this.props.spread &&
      this.props.spread.metadataFields.filter(item => item.name === formKey);
    if (singleId) {
      id = singleId.length > 0 ? singleId[0].id : "";
    }

    const { isDbsJwt } = this.props;
    // hide encap qa team labels
    if (!isDbsJwt && (formKey === QCTeam1 || formKey === QCTeam2)) {
      return null;
    }

    const { spreadCompleted } = this.state;

    const classNameForPeriodOne = "AboutPageForm__period-1__label";
    const className = isPerPeriod
      ? classNameForPeriodOne + " AboutPageForm__period-2__label"
      : classNameForPeriodOne;

    const title = isDisabled
      ? `${label} is not editable`
      : "Not editable on completed spreads";

    return (
      <React.Fragment>
        <label className={className} htmlFor={`AboutPage__${formKey}__input`}>
          {id
            ? isPerPeriod
              ? `${label} FOR ${period} (id=${id})`
              : `${label} (id=${id})`
            : isPerPeriod
            ? `${label} FOR ${period}`
            : label}
          {(isDisabled || spreadCompleted) && (
            <Tooltip
              classes={{ tooltip: "ToolTip-container" }}
              title={title}
              placement="top"
            >
              <img src={LockIconOutlined} />
            </Tooltip>
          )}
        </label>
      </React.Fragment>
    );
  };

  private getSelectField = (
    formFieldData: MetadataInput,
    isAuditForTwoPeriods: boolean
  ) => {
    const { formKey, options, inputType } = formFieldData;
    if (inputType !== "select") {
      return null;
    }

    const optionPeriod = isAuditForTwoPeriods ? 1 : 0;
    let value = this.getMetadataInputOption(formFieldData, optionPeriod);

    const { QCTeam1, QCTeam2 } = MetadataFormKeys;
    const { isDbsJwt } = this.props;

    // hide encap qa team value fields
    if (!isDbsJwt && (formKey === QCTeam1 || formKey === QCTeam2)) {
      return null;
    }

    const isDisabled = isDisabledMetadataFieldOnAboutPage(formFieldData);
    const onChangeFormKey = isAuditForTwoPeriods
      ? `${formKey}SecondPeriod`
      : formKey;
    const classNameForPeriodOne = `AboutPageForm__period-1 AboutPage__${formKey}__input AboutPage__row`;

    const className = isAuditForTwoPeriods
      ? classNameForPeriodOne + " AboutPageForm__period-2__label"
      : classNameForPeriodOne;

    if (value && value.value === "-") {
      value = null;
    }

    return (
      <Select
        placeholder={this.state.spreadCompleted ? "" : "Select..."}
        className={className}
        defaultValue={value}
        options={options}
        onChange={this.handleMetadataInputChange(onChangeFormKey) as any}
        isClearable={true}
        isDisabled={
          isDisabled ||
          this.state.spreadCompleted ||
          formFieldData.isDisabledView
        }
        styles={this.metaConfigStyles}
      />
    );
  };
}

export default connect(
  selectorsToProps({
    spreadName: getSpreadName,
    spreadId: getSpreadId,
    spread: getSpread,
    spreadVersion: getSpreadVersion,
    isDebug: getDebugState,
    user: getUser,
    isCreditLens: isCreditLensFeatureEnabled,
    isDbsJwt: isDbsJwtLoginEnabled,
    requestProgress: getRequestProgress,
    mappingNodeId: getMappingNodeId,
    metadataAboutPageConfig: getMetadataAboutPageConfig,
    shouldDisplayCF,
    exportEnabled: isExportEnabled,
    showRejectSpread,
    showRejectSpreadPopup
  }),
  {
    updateDebugStatus,
    changeSpreadState: changeSpreadState.action,
    exitMappingMode,
    deselectCells,
    showAlertBanner,
    deleteRulesAction: deleteRules.action,
    updateSpreadMetadata: updateSpreadMetadata.action,
    rejectSpreadAction: rejectSpread.action,
    disableTagMode,
    getClientConfig: getClientConfig.action
  }
)(ChartOfAccountsSet);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ChartOfAccountsSet.tsx